export const enum CarBodyType {
  Van = 'van',
  LCV_M = 'lcv_m',
  LCV_L = 'lcv_l',
  LCV_XL = 'lcv_xl',
}

export type Props = {
  name: string
  getFallbackValue(value: string): string | undefined
}
